/* eslint-disable */
/**
 * method命名规则
 * 取url中个性命名部分，使用大写驼峰进行组合，禁止个性化自定义名称，避免该配置文件丢失后，无法找回使用的方法名
 * 如：/api/v1/basic/data，/api/v1/为公共部分，取basic/data组成 BasicData
 */
module.exports = {
  apiConfig: [
    {
      name: '可视化',
      method: 'StatisticsVisualization',
      url: '/api/v1/statistics/visualization',
      type: 'get'
    },
    {
      name: '数据查询',
      method: 'statisticsDataQuery',
      url: '/api/v1/statistics/data/query',
      type: 'get'
    },
    {
      name: '对比分析',
      method: 'contrastiveAnalysis',
      url: '/api/v1/statistics/contrastive/analysis',
      type: 'get'
    },
    {
      name: '统计分析',
      method: 'statisticsAnalysis',
      url: '/api/v1/statistics/analysis',
      type: 'get'
    },
    {
      name: '报告列表',
      method: 'reportRecordPaging',
      url: '/api/v1/report/record/paging',
      type: 'post'
    },
    {
      name: '报告删除',
      method: 'reportRecordDel',
      url: '/api/v1/report/record',
      type: 'delete'
    },
    {
      name: '报告添加',
      method: 'reportRecordAdd',
      url: '/api/v1/report/record',
      type: 'post'
    },
    {
      name: '预览进度查询',
      method: 'reportRecordPreviewProgress',
      url: '/api/v1/report/record/preview/progress',
      type: 'get'
    },
    {
      name: '报告预览',
      method: 'reportRecordPreview',
      url: '/api/v1/report/record/preview',
      type: 'post'
    },
    {
      name: '报告预览',
      method: 'BreedWay',
      url: '/api/v1/statistics/breed/way',
      type: 'get'
    },
    {
      name: '报告预览',
      method: 'BreedType',
      url: '/api/v1/statistics/breed/type',
      type: 'get'
    },
    {
      name: '养殖现状',
      method: 'BreedPlanning',
      url: '/api/v1/breed/present/paging',
      type: 'post'
    },
    {
      name: '存疑图斑圈选',
      method: 'checkSelectedArea',
      url: '/api/v1/breed/present/checkSelectedArea',
      type: 'post'
    },
    {
      name: '养殖现状',
      method: 'BreedPresentPaging',
      url: '/api/v1/breed/present/paging',
      type: 'post'
    },
    {
      name: '养殖现状修改',
      method: 'BreedPresentEdit',
      url: '/api/v1/breed/present',
      type: 'PUT'
    },
    {
      name: '养殖现状删除',
      method: 'BreedPresentDelete',
      url: '/api/v1/breed/present/delete',
      type: 'delete'
    },
    {
      name: '养殖规划',
      method: 'BreedPlanningPaging',
      url: '/api/v1/breed/planning/paging',
      type: 'post'
    },
    {
      name: '养殖规划修改',
      method: 'BreedPlanningEdit',
      url: '/api/v1/breed/planning',
      type: 'put'
    },
    {
      name: '养殖规划删除',
      method: 'BreedPlanningDelete',
      url: '/api/v1/breed/planning/delete',
      type: 'delete'
    },
    {
      name: '养殖数据导入',
      method: 'BreedPlanningImport',
      url: '/api/v1/breed/planning/import',
      type: 'post'
    },
    {
      name: '养殖证数据导入',
      method: 'BreedCertificateImport',
      url: '/api/v1/cred/planning/import',
      type: 'post'
    },
    {
      name: '图斑详情',
      method: 'QueryDetails',
      url: '/api/v1/statistics/data/query/detail',
      type: 'get'
    },
    {
      name: '养殖规划时间',
      method: 'PlanningTime',
      url: '/api/v1/statistics/time/planning',
      type: 'get'
    },
    {
      name: '养殖规划时间通过PlanningType',
      method: 'PlanningTimeByType',
      url: '/api/v1/breed/import/record/paging',
      type: 'post'
    },
    // /api/v1/breed/import/record/importRecordTime
    {
      name: '获取最新的养殖规划时间',
      method: 'GetTmportRecordTime',
      url: '/api/v1/breed/import/record/importRecordTime',
      type: 'get'
    },
    {
      name: '养殖规划时间',
      method: 'PresentTime',
      url: '/api/v1/statistics/time/present',
      type: 'get'
    },
    {
      name: '养殖规划期数',
      method: 'PresentSerial',
      url: '/api/v1/statistics/time/serial',
      type: 'get'
    },
    {
      name: '禁养区现状时间',
      method: 'PresentInPlanningTime',
      url: '/api/v1/statistics/time/present/in/planning',
      type: 'get'
    },
    {
      name: '养殖现状导入记录',
      method: 'ImportRecordPaging',
      url: '/api/v1/breed/import/record/paging',
      type: 'get'
    },
    {
      name: '禁养区内养殖现状',
      method: 'PresentInPlaning',
      url: '/api/v1/breed/present/in/planning/paging',
      type: 'POST'
    },
    {
      name: '禁养区内养殖现状删除',
      method: 'PresentInPlaningDelete',
      url: '/api/v1/breed/present/in/planning/delete',
      type: 'delete'
    },
    {
      name: '禁养区养殖现状',
      method: 'StatisticsPresentInPlanning',
      url: '/api/v1/statistics/present/in/planning',
      type: 'GET'
    },
    {
      name: '禁养区养殖现状修改',
      method: 'StatisticsPresentInPlanningEdit',
      url: '/api/v1/breed/present/in/planning',
      type: 'PUT'
    },
    {
      name: '养殖数据导入记录删除',
      method: 'ImportDataDelete',
      url: '/api/v1/breed/import/record/delete',
      type: 'DELETE'
    },
    {
      name: '处置任务分页查询',
      method: 'GetTaskInfoPaging',
      url: '/api/v1/task/info/paging',
      type: 'POST'
    },
    {
      name: '处置任务统计',
      method: 'statisticsTaskInfo',
      url: '/api/v1/task/info/statistics',
      type: 'POST'
    },
    {
      name: '任务导出',
      method: 'TaskExport',
      url: '/api/v1/task/info/taskExport',
      type: 'POST'
    },
    {
      name: '根据处置任务id获取数据详情',
      method: 'GetTaskInfoDetail',
      url: '/api/v1/task/info/detail',
      type: 'GET'
    },
    {
      name: '下发',
      method: 'SendTaskInfo',
      url: '/api/v1/task/info/send',
      type: 'POST'
    },
    {
      name: '批量下发',
      method: 'SendTaskInfoBatch',
      url: '/api/v1/task/info/send/batch',
      type: 'POST'
    },
    {
      name: '撤回',
      method: 'RollbackTaskInfo',
      url: '/api/v1/task/info/rollback',
      type: 'POST'
    },
    {
      name: '删除',
      method: 'IgnoreTaskInfo',
      url: '/api/v1/task/info/ignore',
      type: 'POST'
    },
    {
      name: '恢复已删除任务',
      method: 'RecoverTaskInfo',
      url: '/api/v1/task/info/recover',
      type: 'POST'
    },
    {
      name: '审核',
      method: 'AuditTaskInfo',
      url: '/api/v1/task/info/audit',
      type: 'POST'
    },
    {
      name: '处置任务-分页查询',
      method: 'TaskInfoPaging',
      url: '/api/v1/task/info/paging',
      type: 'post'
    },
    {
      name: '处置任务-提交',
      method: 'TaskInfoSubmit',
      url: '/api/v1/task/info/submit',
      type: 'post'
    },
    {
      name: '获取存疑图斑判定最小重叠面积',
      method: 'getTaskInfoAreaLimit',
      url: '/api/v1/task/info/area/limit',
      type: 'get'
    },
    {
      name: '修改存疑图斑判定最小重叠面积',
      method: 'modifyTaskInfoAreaLimit',
      url: '/api/v1/task/info/area/limit',
      type: 'put'
    },
    {
      name: '养殖证分页查询',
      method: 'GetCredTaskInfoPaging',
      url: '/api/v1/cred/task/info/paging',
      type: 'post'
    },
    {
      name: '获取养殖证详情',
      method: 'GetCredTaskInfoDetail',
      url: '/api/v1/cred/task/info/detail',
      type: 'get'
    },
    {
      name: '养殖证下发',
      method: 'SendCredTaskInfo',
      url: '/api/v1/cred/task/info/send',
      type: 'post'
    },
    {
      name: '养殖证撤回',
      method: 'RollbackCredTaskInfo',
      url: '/api/v1/cred/task/info/rollback',
      type: 'post'
    },
    {
      name: '养殖证忽略',
      method: 'IgnoreCredTaskInfo',
      url: '/api/v1/cred/task/info/ignore',
      type: 'post'
    },
    {
      name: '批量下发养殖证',
      method: 'BatchSendCredTaskInfo',
      url: '/api/v1/cred/task/info/send/batch',
      type: 'post'
    },
    {
      name: '养殖证处置提交',
      method: 'CredTaskInfoSubmit',
      url: '/api/v1/cred/task/info/submit',
      type: 'post'
    },
    {
      name: '养殖证审核',
      method: 'CredTaskInfoAudit',
      url: '/api/v1/cred/task/info/audit',
      type: 'post'
    },
    {
      name: '养殖证批次时间',
      method: 'CertificateBatchTime',
      url: '/api/v1/cred/planning/time/present',
      type: 'get'
    },
    {
      name: '数据查询-图斑详情',
      method: 'GetCertificateDetail',
      url: '/api/v1/cred/planning/data/query/detail',
      type: 'get'
    },
    {
      name: '获取养殖证详情',
      method: 'GetCredDetail',
      url: '/api/v1/cred/planning/data/query/credDetail',
      type: 'get'
    },
    {
      name: '获取违规图斑判定最小重叠面积',
      method: 'GetCertificateAreaLimit',
      url: '/api/v1/cred/task/info/area/limit',
      type: 'get'
    },
    {
      name: '修改违规图斑判定最小重叠面积',
      method: 'ModifyCertificateAreaLimit',
      url: '/api/v1/cred/task/info/area/limit',
      type: 'put'
    },
    {
      name: '处置任务统计',
      method: 'statisticsCredTaskInfo',
      url: '/api/v1/cred/task/info/statistics',
      type: 'POST'
    },
    {
      name: '养殖证导出',
      method: 'CredTaskExport',
      url: '/api/v1/cred/task/info/taskExport',
      type: 'POST'
    },
    {
      name: '行政区划统计',
      method: 'RegionalStatistics',
      url: '/api/vi/cred/statistics/regional',
      type: 'get'
    },
    {
      name: '养殖类型统计',
      method: 'GetCredTypeStatistics',
      url: '/api/vi/cred/statistics/type',
      type: 'get'
    },
    {
      name: '申请人类别统计',
      method: 'GetApplyTypeStatistics',
      url: '/api/vi/cred/statistics/apply',
      type: 'get'
    },
    {
      name: '养殖证状态统计',
      method: 'GetCertificateStatusStatistics',
      url: '/api/vi/cred/statistics/status',
      type: 'get'
    },
    {
      name: '养殖类型列表',
      method: 'GetMudflatMethodList',
      url: '/api/vi/cred/statistics/mudflatMethod',
      type: 'get'
    },
    {
      name: '养殖证导入记录分页查询',
      method: 'GetCredPlanningPaging',
      url: '/api/v1/cred/planning/paging',
      type: 'post'
    },
    {
      name: '删除养殖证',
      method: 'DeleteCredPlanning',
      url: '/api/v1/cred/planning/delete',
      type: 'delete'
    },
    {
      name: '养殖证批次时间',
      method: 'GetCredPlanningTime',
      url: '/api/v1/cred/planning/time/present',
      type: 'get'
    },
    {
      name: '养殖证存疑图斑圈选',
      method: 'checkSelectedAreaCred',
      url: '/api/v1/cred/planning/checkSelectedArea',
      type: 'post'
    }
  ]
}
